// handling of call button on sender profiles
import IVXCashObject from "./Interfaces/IVXCashObject";
import "core-js/stable";
import "regenerator-runtime/runtime";
import 'whatwg-fetch';
import 'mdn-polyfills/Element.prototype.closest';
import 'mdn-polyfills/Node.prototype.replaceWith';
import OverlayHandler from "./OverlayHandler";
import * as helper from "./helper";
import firstCountry from "./Functions/firstCountry";

declare var vxcash_obj: IVXCashObject;

helper.addEventListener(window, 'DOMContentLoaded', () => {
    const callButton = document.querySelector('.basCallBtn');
    if (callButton !== null) {
        const handler = new OverlayHandler();
        const host = JSON.parse(helper.getData(callButton, 'host'));
        const currentCountry = firstCountry();

        helper.addEventListener(callButton, 'click', (e: MouseEvent) => {
            e.preventDefault();
            handler.show(host, vxcash_obj.numbers[currentCountry]);
        });
    }
})
